import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AuthService } from "@core/service/auth.service";
import { Router } from "@angular/router";
import { IUser } from "@schema/user";
import { BehaviorSubject } from "rxjs";

import { IconList } from "@schema/ui/icons";
import { faUser } from "@fortawesome/pro-light-svg-icons";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { ChangePasswordModalComponent } from "@shared/component/modals/change-password-modal/change-password-modal.component";
import { ChangeProfileModalComponent } from "@shared/component/modals/change-profile-modal/change-profile-modal.component";
import { LoadingStatusService } from "@core/service/loading-status.service";

@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  styleUrls: ["./top-nav.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavComponent implements OnInit {

  public user$: BehaviorSubject<IUser>;

  /**
   * A list of Font Awesome icons used in this component
   */
  public icons: IconList = {
    profile: faUser,
  };

  constructor(
    protected _authService: AuthService,
    protected _modalService: NgbModal,
    protected _router: Router,
    public readonly loadingStatusService: LoadingStatusService,
  ) { }

  ngOnInit(): void {
    this._authService.getProfile();
    this.user$ = this._authService.user$;
  }

  /**
   * Logs the user out.
   */
  public logout() {
    this._authService.logout();
  }

  /**
   * View the user's profile and settings
   */
  public viewPersonalSettings() {
    // TODO
  }
  public viewAdminSettings() {
    // TODO
  }
  public openPasswordModal() {
    this._modalService.open(ChangePasswordModalComponent);
  }
  public openProfileModal() {
    this._modalService.open(ChangeProfileModalComponent);
  }


}
